import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import Icona from '../ui/Icona';
import styles from './videobasic.module.scss';

const VideoBasic = (props) => {
    const { urlMp4, urlWebm, urlWmv, urlOgv, playOnView = true, tresholdPlayOnView = 50, estil, isActive = true } = props;
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(true);
    const [isMuted, setIsMuted] = useState(true);
    const [isInView, setIsInView] = useState(!playOnView);
    const stylesPlayer = clsx({
        [styles.content]: true,
        [styles[estil]]: !!estil
    });

    const stylesVideoWrapper = clsx({
        [styles.videoWrapper]: true
    });

    const handlePlayPause = (event) => {
        event.stopPropagation();
        event.preventDefault();

        const video = videoRef.current;

        if (!video) {
            return;
        }

        if (isPlaying) {
            video.pause();
        } else {
            video.play();
        }

        setIsPlaying(!isPlaying);
    };

    const handleMute = (event) => {
        event.stopPropagation();
        event.preventDefault();

        const video = videoRef.current;

        if (!video) {
            return;
        }

        const nextIsMuted = !isMuted;
        video.muted = nextIsMuted;
        setIsMuted(nextIsMuted);
    };

    useEffect(() => {
        if (!playOnView || typeof IntersectionObserver !== 'function') {
            return;
        }

        const video = videoRef.current;

        if (!video) {
            return;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsInView(entry.isIntersecting);
            },
            {
                threshold: tresholdPlayOnView / 100
            }
        );

        observer.observe(video);

        return () => observer.disconnect();
    }, [playOnView, tresholdPlayOnView]);

    useEffect(() => {
        const video = videoRef.current;

        if (!video) {
            return;
        }

        if (!isActive || (playOnView && !isInView)) {
            video.pause();
            setIsPlaying(false);
            return;
        }

        video.play();
        setIsPlaying(true);
    }, [isActive, isInView, playOnView]);

    if (!urlMp4 && !urlWebm && !urlOgv && !urlWmv) {
        return null;
    }

    return (
        <div className={styles.videoAnimat}>
            <div className={stylesPlayer}>
                <div className={stylesVideoWrapper}>
                    <video ref={videoRef} autoPlay={!playOnView} playsInline muted={isMuted} loop>
                        {urlMp4 && <source src={urlMp4} type='video/mp4' />}
                        {urlWebm && <source src={urlWebm} type='video/webm' />}
                        {urlWmv && <source src={urlWmv} type='video/wmv' />}
                        {urlOgv && <source src={urlOgv} type='video/ogv' />}
                    </video>
                    <div className={styles.controls}>
                        <button type='button' onClick={handlePlayPause} className={styles.botoPlayPause}>
                            {!isPlaying ? (
                                <Icona
                                    className={styles.icona}
                                    icona='play'
                                    alt='Reprodueix el video'
                                    isBlanc={true}
                                    inline={true}
                                />
                            ) : (
                                <Icona
                                    className={styles.icona}
                                    icona='pause_ple'
                                    alt='Aturar el video'
                                    isBlanc={true}
                                    inline={true}
                                />
                            )}
                        </button>
                        <button type='button' onClick={handleMute} className={styles.botoPlayPause}>
                            {isMuted ? (
                                <Icona
                                    className={styles.icona}
                                    icona='novolum'
                                    alt='Activar el so del video'
                                    isBlanc={true}
                                    inline={true}
                                />
                            ) : (
                                <Icona
                                    className={styles.icona}
                                    icona='volum'
                                    alt='Silenciar el video'
                                    isBlanc={true}
                                    inline={true}
                                />
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VideoBasic;
